module.exports = __webpack_public_path__ + "static/media/deal-finder-preview.5fd6b1a1.jpg";